export type AuthorizationSSOConfiguration = {
  authorizationEndpoint: string
  clientId: string
  endSessionEndpoint: string
  isActive: boolean
  redirectUri: string
  tokenEndpoint: string
}

export enum FactoryAllowedLoginType {
  PASSWORD = 'PASSWORD',
  SSO = 'SSO',
  PASSWORD_AND_SSO = 'PASSWORD_AND_SSO'
}

export enum PersonAllowedLoginType {
  PASSWORD = 'PASSWORD',
  SSO = 'SSO',
}

export interface LoginProps {
  applicationId: string
  applicationName: string
  isFetchingUserConfiguration: boolean
  allowedLoginType: FactoryAllowedLoginType
}

export type LoginOptions = {
  clientId: string
  logoutUrl: string
}

export type LoginOptionsAPIResponse = {
  CLIENT_ID: string
  LOGOUT_ENDPOINT: string
}

export enum LoginTypeOptions {
  Django, Ldap, AD, SSO, SAML
}

export type LoginSettingsAPIResponse = {
  TYPE: LoginTypeOptions
  OPTIONS?: LoginOptionsAPIResponse
}

export type LoginSettings = {
  loginType: LoginTypeOptions
  loginOptions: LoginOptions
}

export interface BaseConfigurationType {
  companyName: string
  availableLanguage: string[]
  factoryName: string
  factoryTimeZone: string
  logingSettings: LoginSettings
}

export type LogoutEmit = (e: 'logoutSuccess') => void
